import Box from '@zenbusiness/zui/Box';
import superstyled from '@zenbusiness/zui/styles/superstyled';

// Main container - matches ReportPanel's MainContent structure
export const MainContent = superstyled({
  name: 'ListPanel',
  slot: 'MainContent',
  tag: Box,
  styles: ({ theme }) => ({
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: theme.palette.background.paper,
    border: `1px solid ${theme.palette.border.main}`,
    borderRadius: theme.shape.rounded.lg,
    overflow: 'hidden'
  })
});

// Header area with selection count and export button
export const ContentHeader = superstyled({
  name: 'ListPanel',
  slot: 'ContentHeader',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(2),
    padding: theme.spacing(3),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(1.5)
    }
  })
});

// Row containing selection count and export button
export const HeaderRow = superstyled({
  name: 'ListPanel',
  slot: 'HeaderRow',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    gap: theme.spacing(2)
  })
});

// Selection count text
export const SelectionCount = superstyled({
  name: 'ListPanel',
  slot: 'SelectionCount',
  tag: Box,
  styles: ({ theme }) => ({
    fontSize: theme.typography.fontSize.sm,
    lineHeight: '16px',
    color: theme.palette.text.tertiary || theme.palette.text.secondary
  })
});

// Scrollable content body
export const ContentBody = superstyled({
  name: 'ListPanel',
  slot: 'ContentBody',
  tag: Box,
  styles: ({ theme }) => ({
    flex: 1,
    overflow: 'auto',
    padding: theme.spacing(0, 3, 3, 3),
    [theme.breakpoints.down('md')]: {
      padding: theme.spacing(0, 1.5, 1.5, 1.5)
    }
  })
});

// Container for list items
export const ItemsList = superstyled({
  name: 'ListPanel',
  slot: 'ItemsList',
  tag: Box,
  styles: ({ theme }) => ({
    display: 'flex',
    flexDirection: 'column',
    gap: theme.spacing(3)
  })
});

// Footer section for bottom export button
export const FooterSection = superstyled({
  name: 'ListPanel',
  slot: 'FooterSection',
  tag: Box,
  styles: ({ theme }) => ({
    marginTop: theme.spacing(3)
  })
});
